import { useAuth } from '@clerk/react';
import type { SearchMembershipsQueryDto } from '@shared/dto/auth/search-memberships.query.dto';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { AuthService, type IAuthService } from '../../services/auth/auth.service';

interface UseMembershipSearchOptions {
  enabled?: boolean;
}

export function useMembershipSearch(
  query: SearchMembershipsQueryDto,
  { enabled = true }: UseMembershipSearchOptions = {},
) {
  const authService = useInjection<IAuthService>(AuthService);
  const { isSignedIn } = useAuth();

  return useQuery({
    queryKey: ['auth', 'memberships', 'search', query],
    queryFn: () => authService.searchMemberships(query),
    enabled: enabled && !!isSignedIn,
    placeholderData: keepPreviousData,
  });
}
